import {timeFormat } from "d3";

export const addDays = function (date: Date, days : number) {
    date.setDate(date.getDate() + days);
    return date;
}


const timeFormatter = timeFormat("%a %d/%m")

const translate = (d: string) => {
    const weekDay = d.slice(0, 3);
    let translatedWeekDay
    switch (weekDay) {
        case 'Mon':
            translatedWeekDay = 'Seg';
            break;
        case 'Tue':
            translatedWeekDay = 'Ter';
            break;
        case 'Wed':
            translatedWeekDay = 'Qua';
            break;
        case 'Thu':
            translatedWeekDay = 'Qui';
            break;
        case 'Fri':
            translatedWeekDay = 'Sex';
            break;
        case 'Sat':
            translatedWeekDay = 'Sáb';
            break;
        case 'Sun':
            translatedWeekDay = 'Dom';
            break;         
    }

    return `${translatedWeekDay} ${d.slice(4,d.length)}`;
}

export const tickerFormatter = (timestamp: number) => translate(timeFormatter(new Date(timestamp)));

